module.exports = __webpack_public_path__ + "img/logo-en.81445754.png";